module.exports = __webpack_public_path__ + "img/404-uk.dad5266.svg";